import { render } from "./EmployeeApprovedRequests.vue?vue&type=template&id=b9d59ab0"
import script from "./EmployeeApprovedRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovedRequests.vue?vue&type=script&lang=js"

import "./EmployeeApprovedRequests.vue?vue&type=style&index=0&id=b9d59ab0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__